import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MembershipRequestBody, MembershipResponse } from "./types";

export class MembershipAPI extends BaseAPI<
  MembershipRequestBody,
  MembershipResponse
> {
  protected route = ApiRoutes.auth.membership;
  protected method = RequestMethod.PUT;
}
